import {get} from 'lodash';

import {useTranslation} from '/provider/TranslationProvider';

interface FrontlineClientRoleItem {
  isFrontline: boolean;
}
interface FrontlineClientRoleProps {
  item: FrontlineClientRoleItem | null;
}

export const FrontlineClientRole: React.FC<FrontlineClientRoleProps> = ({
  item = null,
}: FrontlineClientRoleProps) => {
  const {tt} = useTranslation('report.record.frontlineClientRole');
  const isFrontline = get(item, 'isFrontline', false);

  if (!isFrontline) {
    return null;
  }

  return tt('frontline', 'Client · Frontline');
};
